import { render, staticRenderFns } from "./FormulaAlreadyListed.vue?vue&type=template&id=56311c3b&scoped=true"
import script from "./FormulaAlreadyListed.vue?vue&type=script&lang=js"
export * from "./FormulaAlreadyListed.vue?vue&type=script&lang=js"
import style0 from "./FormulaAlreadyListed.vue?vue&type=style&index=0&id=56311c3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56311c3b",
  null
  
)

export default component.exports